import {gql} from '@apollo/client';

import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';

export const GET_MOLECULAR_WEIGHT_QUERY = gql`
  query GetMolecularWeightQuery($moleculeIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            molecularWeight {
              ... on MolecularWeightNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_VERSIONED_MOLECULAR_WEIGHT_QUERY = gql`
  query GetVersionedMolecularWeightQuery($moleculeVersionSpecifiers: [MoleculeVersionSpecifierInput!]!)
  @skipAudit
  @engComponent(name: CHEMISTRY) {
    moleculeVersions(moleculeVersionSpecifiers: $moleculeVersionSpecifiers) {
      ... on MoleculeVersionNode {
        id
        chemicalStructure {
          id
          molecularWeight {
            ... on MolecularWeightNode {
              value
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_FORMULA_WEIGHT_QUERY = gql`
  query GetFormulaWeightQuery($moleculeIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            formulaWeight {
              ... on FloatPropertyNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_VERSIONED_FORMULA_WEIGHT_QUERY = gql`
  query GetVersionedFormulaWeightQuery($moleculeVersionSpecifiers: [MoleculeVersionSpecifierInput!]!)
  @skipAudit
  @engComponent(name: CHEMISTRY) {
    moleculeVersions(moleculeVersionSpecifiers: $moleculeVersionSpecifiers) {
      ... on MoleculeVersionNode {
        id
        chemicalStructure {
          id
          formulaWeight {
            ... on FloatPropertyNode {
              value
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_MOLECULAR_FORMULA_QUERY = gql`
  query GetMolecularFormulaQuery($moleculeIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            chemicalFormula {
              ... on ChemicalFormulaNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_IUPAC_NAME_QUERY = gql`
  query GetIupacNameQuery($moleculeIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            iupacName {
              ... on StringPropertyNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_IUPAC_NAME_FROM_SMILES_QUERY = gql`
  query GetIupacNameFromSmilesQuery($smiles: StrictString!) @skipAudit @engComponent(name: CHEMISTRY) {
    iupacNameFromSmiles(smiles: $smiles) {
      ... on StringPropertyNode {
        value
      }
    }
  }
`;

export const GET_CHEMICAL_PROPERTIES_FROM_SMILES_QUERY = gql`
  query GetChemicalPropertiesFromSmilesQuery($smiles: StrictString!)
  @skipAudit
  @engComponent(name: CHEMISTRY) {
    chemicalPropertiesFromSmiles(smiles: $smiles) {
      ... on ChemicalPropertiesFromSmilesNode {
        molecularWeight {
          ... on FloatPropertyNode {
            value
          }
        }
        formulaWeight {
          ... on FloatPropertyNode {
            value
          }
        }
        chemicalFormula {
          ... on ChemicalFormulaNode {
            value
          }
        }
      }
    }
  }
`;

export const GET_CAS_REGISTRY_NUMBER_QUERY = gql`
  query GetCasRegistryNumberQuery($moleculeIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          chemicalStructure {
            id
            casRegistryNumber {
              ... on StringPropertyNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_MOLECULE_CURRENT_VERSION_QUERY = gql`
  query GetMoleculeCurrentVersionQuery($moleculeIds: [StrictString!]!)
  @skipAudit
  @engComponent(name: CHEMISTRY) {
    molecules(ids: $moleculeIds) {
      ... on MoleculeNode {
        id
        currentVersion {
          id
          modifiedAt
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;

export const GET_LOT_PROPERTIES_QUERY = gql`
  query GetLotPropertiesQuery($lotIds: [StrictString!]!) @skipAudit @engComponent(name: CHEMISTRY) {
    bioentities(ids: $lotIds) {
      ... on RegistryItemInterface {
        id
        name
        tagsJson
        tagSchema {
          ... on TagSchemaNode {
            id
            interfaces {
              id
            }
          }
        }
      }
      ... on MoleculeNode {
        id
        currentVersion {
          id
          modifiedAt
          chemicalStructure {
            id
            molecularWeight {
              ... on MolecularWeightNode {
                value
              }
            }
            formulaWeight {
              ... on FloatPropertyNode {
                value
              }
            }
          }
        }
      }
      ...InaccessibleInfoGraphQL
    }
  }
  ${getFragmentWrapper('InaccessibleInfo').fragment}
`;
